import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ValidationIcons from './../../../reusable/ValidationIcons/ValidationIcons';

import {
    EXPERIAN_VALIDATION_VALID,
    EXPERIAN_VALIDATION_INVALID,
    EXPERIAN_VALIDATION_LOADING }
        from './../../../constants';

export default class EditEntityExperianCheck extends React.Component {

    static propTypes = {
        experian:           PropTypes.string,
        experianResponse:   PropTypes.object,
        checkExperian:      PropTypes.func,
        autorun:            PropTypes.bool
    };

    static defaultProps = {
        autorun: false
    }

    constructor(props) {
        super(props);
        this.state = {
            experianCheckState: props.experianResponse ?
                (props.experianResponse.success ? EXPERIAN_VALIDATION_VALID : EXPERIAN_VALIDATION_INVALID) : false
        };

        this.checkExperian = this.checkExperian.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            experianCheckState: newProps.experianResponse ?
                newProps.experianResponse.loading ? EXPERIAN_VALIDATION_LOADING :
                newProps.experianResponse.success ? EXPERIAN_VALIDATION_VALID : EXPERIAN_VALIDATION_INVALID : false
        })
    }

    checkExperian() {
        this.props.checkExperian()

        this.setState({
            experianCheckState: EXPERIAN_VALIDATION_LOADING
        });
    }

    render() {
        let experianCheckResponseClasses = 'valid';
        if (this.state.experianCheckState === EXPERIAN_VALIDATION_INVALID) {
            experianCheckResponseClasses = 'invalid';
        }
        return (
            <span className="experian-check">
                    {
                        !this.state.experianCheckState ?
                            <button type="button"
                                    className="button-doc-sm"
                                    onClick={this.checkExperian}>
                                <span><FormattedMessage id="Entities_Edit_UIText_editThirdParty.validate" /></span>
                            </button>
                            :
                            <ValidationIcons renderState={this.state.experianCheckState} />
                    }
                <div className={"experian-check__response " + experianCheckResponseClasses}>
                    {this.state.experianContent}
                </div>
            </span>
        );

    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityExperianCheck.jsx